/**
 * Demo mock state for Maya · TTC · My Cycle (/demo/trying-to-conceive/cycle).
 * Production would hydrate from user profile + cycle logs; Oura uses API V2
 * (daily_readiness.temperature_deviation) with tokens stored server-side per session.
 */

export const TTC_MAYA_CYCLE = {
  userName: 'Maya',
  cycleNumber: 4,
  cycleDay: 14,
  monthsTryingLabel: '4 months trying',
  fertileBadgeLabel: 'Fertile window open',
  novaCheckIn:
    'Day 14 — peak fertile window. Your BBT this morning was up 0.3°F from your pre-ovulation average. Did you test with an OPK yet? I can help you read the result.',
  todayLog: {
    bbt: {
      value: '97.8°F',
      sub: '7:02am · +0.3°F from avg',
      ouraSynced: false,
    },
    opk: { value: 'Peak', sub: '8:15am · strong surge' },
    cm: { value: 'Not logged', sub: null, muted: true },
  },
  cycleStatusRows: [
    { label: 'Cycle day', value: '14', valueColor: 'var(--purple-d)' },
    { label: 'Phase', value: 'Ovulatory' },
    { label: 'Fertile window', value: 'Days 13–15', valueColor: 'var(--purple-d)' },
    { label: 'LH surge detected', value: 'Today', valueColor: 'var(--purple-d)' },
    { label: 'Ovulation confirmed', value: 'BBT + OPK', valueColor: 'var(--purple-d)' },
    { label: 'TWW starts', value: 'Apr 16' },
    { label: 'Next period est.', value: 'Apr 26–28' },
    { label: 'Cycle length avg', value: '28 days' },
  ],
  bbtPhaseStrip: [
    { label: 'Menstrual', flex: 3, bg: 'var(--purple-l)', color: 'var(--purple-d)' },
    { label: 'Follicular', flex: 4, bg: 'var(--purple-m)', color: '#26215c' },
    { label: 'Ovul.', flex: 2, bg: 'var(--purple)', color: '#FFFFFF', fontSize: 10 },
    { label: 'Luteal', flex: 5, bg: 'var(--purple-l)', color: 'var(--purple-d)' },
  ],
  /** 13 pre-O bars as fraction of container (0.28–0.38); last bar is today’s shift */
  bbtBarFracs: [0.3, 0.32, 0.28, 0.35, 0.31, 0.33, 0.29, 0.36, 0.34, 0.3, 0.32, 0.35, 0.38],
  bbtStats: [
    { label: 'Pre-ovulation avg', value: '97.4°F' },
    { label: 'Today', value: '97.8°F', valueColor: 'var(--purple-d)' },
    { label: 'Shift', value: '+0.4°F confirmed', valueColor: 'var(--purple-d)' },
    { label: 'Luteal phase so far', value: 'Day 1 of est. 11' },
  ],
  intelligencePatterns: [
    {
      icon: '📊',
      iconBg: 'var(--purple-l)',
      title: 'Fertile window shifted earlier',
      titleColor: 'var(--text)',
      sub:
        'Last 3 cycles peaked Day 12–14. This cycle your LH surge came Day 10 — 2 days earlier than usual. Log closely from Day 8 next month.',
      flag: { label: 'Pattern detected', bg: 'var(--purple-l)', color: 'var(--purple-d)' },
    },
    {
      icon: '🌡️',
      iconBg: 'var(--purple-l)',
      title: 'Thermal shift confirmed ovulation',
      titleColor: 'var(--text)',
      sub:
        'BBT rose +0.4°F after your LH surge this cycle — confirming ovulation around Day 10. OPK and BBT signals aligned for the first time across 4 cycles.',
      flag: { label: 'Confirmed', bg: '#E1F5EE', color: '#085041' },
    },
    {
      icon: '⏱️',
      iconBg: '#FEF0EB',
      title: 'Short luteal phase — 3 cycles in a row',
      titleColor: '#AD3F1A',
      sub:
        '10–11 days for 3 consecutive cycles. Worth mentioning to your doctor if you do not conceive this cycle. Nova has prepared a note for your next appointment.',
      flag: { label: 'Worth discussing', bg: '#FEF0EB', color: '#AD3F1A' },
    },
    {
      icon: '💡',
      iconBg: 'var(--purple-l)',
      title: "Nova's cycle note",
      titleColor: 'var(--text)',
      sub:
        'Your data across 4 cycles shows consistent ovulation — a strong positive signal. The short luteal phase is the one pattern worth tracking. Everything else looks healthy.',
      flag: null,
    },
  ],
};

export const OURA_SESSION_KEY = 'orivonai:ttcDemoOuraOAuth';
